import addCheckboxClassToColumnHeadersFactory from './addCheckboxClassToColumnHeadersFactory';
import multiSelectClickHandlerFactory from './multiSelectClickHandlerFactory';
import selectClickHandlerFactory from './selectClickHandlerFactory';

export default {
  afterGetColHeader: { addCheckboxClassToColumnHeadersFactory },
  afterOnCellMouseDown: { selectClickHandlerFactory },
  beforeOnCellMouseDown: { multiSelectClickHandlerFactory },
};
